// @ts-nocheck
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';

const CustomTooltip = ({ active, payload, label, currencySymbol }) => {
    if (active && payload && payload.length) {
        const value = payload[0].value;
        const formattedValue = new Intl.NumberFormat('fr-FR').format(value);
        return (
            <div className="bg-white p-2 border border-gray-300 rounded shadow-lg">
                <p className="font-bold">{`${label}`}</p>
                <p style={{ color: payload[0].color }}>{`Montant : ${formattedValue} ${currencySymbol}`}</p>
            </div>
        );
    }
    return null;
};

export default function BudgetWaterfallChart({ data, currencySymbol }) {
    const chartData = [
        { name: 'Budget Initial', value: data.initial, color: '#14B8A6' }, // teal-500
        { name: 'Engagé', value: -data.engaged, color: '#3B82F6' }, // blue-500
        { name: 'Dépensé', value: -data.spent, color: '#F97316' }, // orange-500
        { name: 'Restant', value: data.remaining, color: '#22C55E' }, // green-500
    ];

    return (
        <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis tickFormatter={(value) => new Intl.NumberFormat('fr-FR', { notation: 'compact' }).format(value)} />
                <Tooltip content={(props) => <CustomTooltip {...props} currencySymbol={currencySymbol} />} />
                <Bar dataKey="value" fill="#8884d8">
                    {chartData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
}
